module.exports = __webpack_public_path__ + "static/media/image-video-6.e805119b.png";